import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import { Client } from '@/types/client';
import Table from '@/components/molecules/section/Table';
import Container from '@/components/molecules/section/Container';
import { usePersonaKycHistos } from '@/hooks/client';
import useTable from '@/hooks/table';
import { transformDateStringFrance } from '@/utilities/datetime';

const defaultPageSize = 10;
const DEFAULT_EMPTY = '-';

const KycTable: React.FC<{ client: Client }> = ({ client }) => {
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(false);

  const { page, pageSize, totalItems, onPageChange, persistTotalItems } = useTable(defaultPageSize);

  const { data: personaKyc, isFetching } = usePersonaKycHistos(Number(client.clientId), page, pageSize, open);

  useEffect(() => {
    if (personaKyc) persistTotalItems(personaKyc.total || 0);
  }, [personaKyc]);

  const columns: GridColDef[] = [
    { field: 'createdAt', headerName: t('client.kyc.requested_date') },
    { field: 'requestTypeDisplayText', headerName: t('client.kyc.reason') },
    { field: 'status', headerName: t('client.kyc.status') },
    { field: 'decidedAt', headerName: t('client.kyc.completed_date') },
  ];

  const rows = personaKyc
    ? personaKyc.data.map((item, index) => ({
        id: index,
        createdAt: item.createdAt ? transformDateStringFrance(item.createdAt) : DEFAULT_EMPTY,
        requestTypeDisplayText: item.requestTypeDisplayText || DEFAULT_EMPTY,
        status: item.status || DEFAULT_EMPTY,
        decidedAt: item.decidedAt ? transformDateStringFrance(item.decidedAt) : DEFAULT_EMPTY,
      }))
    : [];

  return (
    <Container
      title={t('client.kyc.persona_kyc')}
      actions={[]}
      handler={{ open, setOpen }}
      testId="kyc"
    >
      <Table
        rows={rows}
        columns={columns}
        loading={isFetching}
        table={{
          kind: 'DynamicTable',
          totalItem: totalItems,
          pageSize,
          pageSizeOptions: [5, defaultPageSize, 50],
          onPageChange,
        }}
        sx={{
          '& .MuiDataGrid-cell': {
            display: 'flex !important',
            padding: '0.6rem 1rem !important',
            alignItems: 'center !important',
          },
        }}
      />
    </Container>
  );
};

export default KycTable;
